import Part from '../part/Part';
import capitalizeFirstLetter from '../../../../utils/capitalizeFirstLetter';
import { NavLink, useLocation } from 'react-router-dom';
import { useSessionContext } from "../../contexts/sectionContext";
import './LinkPart.css';
import { isPwa } from '/src/utils/isPwa';

function LinkPart({ name, url, label,externalLink, plural,numberOfData, onClick }) {
    const location = useLocation();
    const { setSectionTroughtEventClick } = useSessionContext();

    const _url =  externalLink != null ? externalLink :  url;
    const match = location.pathname.match(`${_url}`);
    return (
        <Part isSelected={match} name={name}>
            {
                externalLink == null ?
                    <div className={match ? 'selected' : ''}>
                        <button onClick={()=> onClick()}>
                            <div className={'svg ' + name.replace(/\s+/g, '_')}></div>
                            <span className="parent_txt home_txt">{capitalizeFirstLetter(label ? label : name) + (plural ? "s" : "")} { (numberOfData != null && numberOfData > 0) ? "("+numberOfData +")" : "" }</span>
                        </button>
                    </div>
                    :
                    <div className={match ? 'selected' : ''}>
                        <div onClick={onClick}>
                            <button>
                                <div onClick={setSectionTroughtEventClick}></div>
                                <div className={'svg ' + name}></div>
                                <span className="parent_txt home_txt">{capitalizeFirstLetter(label ? label : name)} </span>
                            </button>
                        </div>
                    </div>



            }


        </Part>
    )
}

export default LinkPart;